
























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVendorCompany } from '@/api/types-vendor'

@Component({
  name: 'VendorCompany'
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IVendorCompany;
}
